var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",staticStyle:{"margin-bottom":"16px","cursor":"pointer","min-width":"200px"},on:{"click":_vm.goBack}},[_c('SvgIcon',{staticClass:"icon-24",attrs:{"type":"back"}}),_c('p',{staticClass:"back"},[_vm._v(_vm._s(_vm.backText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }